import React from 'react'

import RequestRemoteAccess from 'pages/Customer/RemoteConfiguration/RequestRemoteAccess'
import RequestRemoteStatus from 'pages/Customer/RemoteConfiguration/RequestRemoteStatus'

import useRemoteConfigCompatible from 'hooks/useRemoteConfigCompatible'
import { useStoreContext } from 'hooks/StoreContext'
import useNexiaStream from 'hooks/useNexiaStream'

import { DeviceBase } from 'types/Device'

type Props = {
  device: DeviceBase
  className?: string
}

const RemoteConfiguration = ({ device, className = '' }: Props) => {
  const { reportCache } = useStoreContext()
  const { eventData: report } = useNexiaStream(device.deviceId, 'current_status', reportCache)
  const connected = report ? report.connected : device.connected
  const { compatible } = useRemoteConfigCompatible(device.deviceId, connected)
  const { eventData: status } = useNexiaStream(device.deviceId, 'remote_config_session', reportCache, compatible)

  return (
    <div className={className}>
      {
        compatible && status && (
          status.state === 'inactive'
            ? <RequestRemoteAccess device={device} />
            : <RequestRemoteStatus status={status} device={device} />
        )
      }
    </div>
  )
}

export default RemoteConfiguration
